import { TranslationsStoreProvider } from './TranslationsStore';
import { combineStoreProviders } from './combineStoreProviders';

const providers = [TranslationsStoreProvider];

const FloqLiveStoreProviders = combineStoreProviders(...providers);

export default FloqLiveStoreProviders;
